<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="toolbarButtons" @callFunction="callFunction" :searchList="searchList">
      </toolbar>

      <template v-if="listLoading || (list && list.length > 0)">
        <div class="tbl-scroll-host">
          <el-table :data="pagedList" v-loading="listLoading" stripe border size="small" class="custom-tbl sc-stat-table" height="100%">
              <el-table-column label="教师" width="" show-overflow-tooltip>
                <template slot-scope="scope">{{ field(scope.row, 'teacherName') }}</template>
              </el-table-column>
              <el-table-column label="主教Id" width="150" align="center">
                <template slot-scope="scope">{{ field(scope.row, 'teacherMasterId') }}</template>
              </el-table-column>
              <el-table-column label="应上" width="" align="center">
                <template slot-scope="scope">{{ field(scope.row, 'plannedCount') }}</template>
              </el-table-column>
              <el-table-column label="正常" width="" align="center">
                <template slot-scope="scope">{{ field(scope.row, 'normalCount') }}</template>
              </el-table-column>
              <el-table-column label="缺席" width="" align="center">
                <template slot-scope="scope">{{ field(scope.row, 'absenceCount') }}</template>
              </el-table-column>
              <el-table-column label="代班进" width="" align="center">
                <template slot-scope="scope">{{ field(scope.row, 'substituteInCount') }}</template>
              </el-table-column>
              <el-table-column label="实上" width="" align="center">
                <template slot-scope="scope">{{ field(scope.row, 'actualCount') }}</template>
              </el-table-column>
              <el-table-column label="到岗率" width="96" align="center">
                <template slot-scope="scope">
                  <span :style="{ color: rateColor(scope.row) }">{{ ratePercent(scope.row) }}%</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="88" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" icon="el-icon-view" class="sc-link-btn" @click="openDetail(scope.row)">明细</el-button>
                </template>
              </el-table-column>
            </el-table>
        </div>
        <el-col v-show="list.length > 0 && !listLoading" :span="24" class="toolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="list.length"
            style="float: right"
            @current-change="onPageChange"
            @size-change="onPageSizeChange"
          />
        </el-col>
      </template>

      <div v-else-if="!listLoading && departmentId" class="sc-stat-empty">
        <i class="el-icon-document"></i>
        <p>当前月份暂无统计数据</p>
        <p class="sc-stat-empty__hint">请调整月份、时段筛选或切换左侧机构后重新查询</p>
      </div>

      <div v-else-if="!listLoading && !departmentId" class="sc-stat-empty">
        <i class="el-icon-s-home"></i>
        <p>请先在左侧选择学校或机构</p>
        <p class="sc-stat-empty__hint">选择后将加载可选时段并支持查询</p>
      </div>

      <el-dialog 
        :title="detailTitle"
        :visible.sync="detailVisible"
        width="920px"
        append-to-body
        :close-on-click-modal="false"
        @closed="onDetailClosed"
      >
        <el-table
          :data="detailPagedList"
          v-loading="detailLoading"
          stripe
          border
          size="small"
          max-height="440"
          class="roll-detail-table"
        >
          <el-table-column label="日期" width="100" align="center" fixed="left">
            <template slot-scope="scope">{{ field(scope.row, 'attendDate') }}</template>
          </el-table-column>
          <el-table-column label="课次 / 班级" min-width="168">
            <template slot-scope="scope">
              <div class="roll-detail-2l">
                <div class="roll-detail-2l__main">{{ field(scope.row, 'sessionName') || '—' }}</div>
                <div class="roll-detail-2l__sub">{{ field(scope.row, 'className') || '—' }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="时段 / 时间" min-width="138">
            <template slot-scope="scope">
              <div class="roll-detail-2l">
                <div class="roll-detail-2l__main">{{ field(scope.row, 'timeName') || '—' }}</div>
                <div class="roll-detail-2l__sub">{{ field(scope.row, 'timeRange') || '—' }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型 / 结果" width="108" align="center">
            <template slot-scope="scope">
              <div class="roll-detail-2l roll-detail-2l--center">
                <div class="roll-detail-2l__main">{{ field(scope.row, 'statKind') || '—' }}</div>
                <div class="roll-detail-2l__sub" :class="detailOutcomeClass(scope.row)">{{ field(scope.row, 'outcome') || '—' }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="值日状态" width="90" align="center">
            <template slot-scope="scope">
              <span :class="dutyAttendanceClass(scope.row)">{{ dutyAttendanceLabel(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="排班来源" width="100" align="center">
            <template slot-scope="scope">{{ scheduleSourceLabel(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="教师 / 记录" min-width="140">
            <template slot-scope="scope">
              <div class="roll-detail-2l">
                <div class="roll-detail-2l__main">{{ field(scope.row, 'scheduledTeacherName') || '—' }}</div>
                <div class="roll-detail-2l__sub">{{ recordSourceLabel(scope.row) }}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="detail-dialog-footer">
          <el-pagination
            class="detail-pager"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="detailPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="detailPageSize"
            :total="detailRows.length"
            @size-change="onDetailSizeChange"
            @current-change="onDetailPageChange"
          />
          <el-button type="primary" plain size="small" icon="el-icon-download" :loading="detailExportLoading" @click="exportDetailExcel">导出明细</el-button>
          <el-button size="small" @click="detailVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { getSpecialCourseTeacherRollMonthStats, getSpecialCourseTeacherRollMonthStatDetails, exportSpecialCourseTeacherRollMonthStats, exportSpecialCourseTeacherRollMonthStatDetails, getSpecialCourseTimeList } from '../../api/modules/schedule-course';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'

export default {
  name: 'SpecialCourseTeacherRollStat',
  components: { Toolbar, DepartmentPane },
  data() {
    const now = new Date()
    const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
    return {
      departmentId: 0,
      filters: {
        statMonth: ym,
        timeId: '',
        teacherName: ''
      },
      timeSelectOptions: [],
      searchList: [
        { label: '统计月份', key: 'statMonth', type: 'month', width: '150px', initValue: ym },
        {
          label: '时段模板',
          key: 'timeId',
          type: 'select',
          clearable: true,
          options: [],
          width: '280px'
        },
        {
          label: '教师',
          key: 'teacherName',
          type: 'input',
          placeholder: '姓名模糊搜索',
          width: '160px',
          initValue: ''
        }
      ],
      list: [],
      listLoading: false,
      page: 1,
      pageSize: 10,
      buttonList: [],
      exportLoading: false,
      detailExportLoading: false,
      detailVisible: false,
      detailLoading: false,
      detailRows: [],
      detailPage: 1,
      detailPageSize: 10,
      detailTeacherName: '',
      detailTeacherMasterId: 0
    }
  },
  computed: {
    pagedList() {
      const arr = this.list || []
      const start = (this.page - 1) * this.pageSize
      return arr.slice(start, start + this.pageSize)
    },
    detailTitle() {
      const n = this.detailTeacherName || '教师'
      return `月到岗明细 · ${n}`
    },
    detailPagedList() {
      const arr = this.detailRows || []
      const start = (this.detailPage - 1) * this.detailPageSize
      return arr.slice(start, start + this.detailPageSize)
    },
    toolbarButtons() {
      if (this.buttonList && this.buttonList.length > 0) {
        return this.buttonList.map((b) => {
          const isExport =
            b.Func === 'exportExcel' || (b.name && String(b.name).indexOf('导出') >= 0)
          return isExport ? { ...b, loading: !!this.exportLoading } : b
        })
      }
      return [
        { name: '查询', Func: 'handleQuery' },
        { name: '导出', Func: 'exportExcel', loading: this.exportLoading }
      ]
    }
  },
  methods: {
    /** 兼容 PascalCase / camelCase */
    field(row, camelKey) {
      if (!row) return ''
      const pascal = camelKey.charAt(0).toUpperCase() + camelKey.slice(1)
      const v = row[camelKey] != null ? row[camelKey] : row[pascal]
      return v != null ? v : ''
    },
    /** 排班来源：Daily/Weekly/Default → 中文（与后端导出一致） */
    scheduleSourceLabel(row) {
      return this.scheduleSourceLabelFromRaw(this.field(row, 'scheduleSource'))
    },
    scheduleSourceLabelFromRaw(raw) {
      const s = String(raw || '').trim()
      if (!s) return '—'
      const lower = s.toLowerCase()
      if (lower === 'daily') return '日排'
      if (lower === 'weekly') return '周模板'
      if (lower === 'default') return '默认'
      return s
    },
    recordSourceLabel(row) {
      return this.recordSourceLabelFromRaw(this.field(row, 'recordSource'))
    },
    recordSourceLabelFromRaw(raw) {
      const s = String(raw || '').trim()
      if (!s) return '—'
      const lower = s.toLowerCase()
      if (lower === 'dutycheck') return '值日检查'
      if (lower === 'studentrollcall') return '学生点名'
      return s
    },
    detailOutcomeClass(row) {
      const o = String(this.field(row, 'outcome') || '')
      if (o.indexOf('缺席') >= 0) return 'roll-detail-out--bad'
      if (o.indexOf('正常') >= 0) return 'roll-detail-out--ok'
      if (o.indexOf('代班') >= 0) return 'roll-detail-out--sub'
      return ''
    },
    dutyAttendanceValue(row) {
      const n = Number(this.field(row, 'dutyAttendance'))
      return n >= 1 && n <= 3 ? n : 0
    },
    dutyAttendanceLabel(row) {
      const n = this.dutyAttendanceValue(row)
      return n === 1 ? '正常' : n === 2 ? '迟到' : n === 3 ? '早退' : '—'
    },
    dutyAttendanceClass(row) {
      const n = this.dutyAttendanceValue(row)
      if (n === 1) return 'roll-duty--ok'
      if (n === 2) return 'roll-duty--warn'
      if (n === 3) return 'roll-duty--bad'
      return 'roll-duty--muted'
    },
    parseStatMonth(str) {
      if (!str || typeof str !== 'string') return null
      const m = str.match(/^(\d{4})-(\d{2})$/)
      if (!m) return null
      const year = parseInt(m[1], 10)
      const month = parseInt(m[2], 10)
      if (month < 1 || month > 12) return null
      return { year, month }
    },
    ratePercent(row) {
      const planned = Number(this.field(row, 'plannedCount')) || 0
      const actual = Number(this.field(row, 'actualCount')) || 0
      if (planned <= 0) return 0
      return Math.round((actual / planned) * 100)
    },
    rateColor(row) {
      const r = this.ratePercent(row)
      if (r >= 95) return '#67c23a'
      if (r >= 80) return '#e6a23c'
      return '#f56c6c'
    },
    formatTimeTemplateLabel(row) {
      const name = (row && (row.TimeName || row.timeName)) || ''
      const campusId = (row && (row.CampusId || row.campusId)) || 0
      const campus = campusId
        ? ((row.CampusName || row.campusName) || '校区')
        : '全校'
      return name ? `${name}（${campus}）` : campus
    },
    patchTimeOptions() {
      const item = this.searchList.find((s) => s.key === 'timeId')
      if (item) item.options = this.timeSelectOptions
    },
    loadTimeOptions() {
      if (!this.departmentId) {
        this.timeSelectOptions = []
        this.patchTimeOptions()
        return
      }
      getSpecialCourseTimeList({
        departmentId: this.departmentId,
        page: 1,
        pageSize: 500
      }).then((res) => {
        const result = res.data || res
        const rows =
          result.success && result.response && result.response.data
            ? result.response.data
            : []
        this.timeSelectOptions = rows
          .filter((r) => r && (r.Id || r.id))
          .map((r) => ({
          label: this.formatTimeTemplateLabel(r),
          value: r.id || r.Id
        }))
        this.patchTimeOptions()
      })
    },
    treeNodeClick(data) {
      this.departmentId = data.value
      this.loadTimeOptions()
      this.handleQuery()
    },
    buildQueryParams() {
      const parsed = this.parseStatMonth(this.filters.statMonth)
      if (!parsed) return null
      const params = {
        departmentId: this.departmentId,
        year: parsed.year,
        month: parsed.month
      }
      const tid = this.filters.timeId
      const n = tid != null && tid !== '' ? Number(tid) : 0
      if (n > 0) params.specialCourseTimeId = n
      const teacherName = (this.filters.teacherName || '').trim()
      if (teacherName) params.teacherName = teacherName
      return params
    },
    handleQuery() {
      if (!this.departmentId) {
        this.$message.error('请先选择机构/学校')
        return
      }
      const params = this.buildQueryParams()
      if (!params) {
        this.$message.error('请选择有效统计月份')
        return
      }
      this.page = 1
      this.listLoading = true
      getSpecialCourseTeacherRollMonthStats(params)
        .then((res) => {
          const result = res.data || res
          this.list = result.success ? result.response || [] : []
        })
        .catch(() => {
          this.list = []
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    onPageChange(p) {
      this.page = p
    },
    onPageSizeChange(s) {
      this.pageSize = s
      this.page = 1
    },
    openDetail(row) {
      const params = this.buildQueryParams()
      if (!params) {
        this.$message.error('请选择有效统计月份')
        return
      }
      const tid = Number(this.field(row, 'teacherMasterId'))
      if (!tid) {
        this.$message.warning('无法识别主教 Id')
        return
      }
      this.detailTeacherMasterId = tid
      this.detailTeacherName = this.field(row, 'teacherName') || ''
      this.detailPage = 1
      this.detailRows = []
      this.detailVisible = true
      this.detailLoading = true
      getSpecialCourseTeacherRollMonthStatDetails({
        ...params,
        teacherMasterId: tid
      })
        .then((res) => {
          const result = res.data || res
          this.detailRows = result.success ? result.response || [] : []
          if (!result.success) this.$message.error(result.msg || '加载明细失败')
        })
        .catch(() => {
          this.detailRows = []
          this.$message.error('加载明细失败')
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    onDetailPageChange(p) {
      this.detailPage = p
    },
    onDetailSizeChange(s) {
      this.detailPageSize = s
      this.detailPage = 1
    },
    onDetailClosed() {
      this.detailRows = []
      this.detailPage = 1
      this.detailTeacherMasterId = 0
      this.detailTeacherName = ''
    },
    callFunction(item) {
      if (item.search && typeof item.search === 'object') {
        this.filters = Object.assign({}, item.search)
      }
      const fn = item.Func
      if (fn && typeof this[fn] === 'function') {
        this[fn](item)
      } else {
        this.handleQuery()
      }
    },
    saveBlobFile(blob, fileName) {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    exportExcel() {
      if (!this.departmentId) {
        this.$message.error('请先选择机构/学校')
        return
      }
      const params = this.buildQueryParams()
      if (!params) {
        this.$message.error('请选择有效统计月份')
        return
      }
      return exportSpecialCourseTeacherRollMonthStats(params)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const cd = res.headers['content-disposition']
          let name = `特殊课程教师月到岗统计_${Date.now()}.xlsx`
          if (cd) {
            const m = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd)
            const raw = decodeURIComponent((m && (m[1] || m[2])) || '').trim()
            if (raw) name = raw
          }
          this.saveBlobFile(blob, name)
          this.$message.success('导出成功')
        })
        .catch(() => {
          this.$message.error('导出失败')
        })
    },
    exportDetailExcel() {
      if (!this.detailTeacherMasterId) {
        this.$message.warning('请先打开某位教师的明细')
        return
      }
      const params = this.buildQueryParams()
      if (!params) {
        this.$message.error('请选择有效统计月份')
        return
      }
      this.detailExportLoading = true
      exportSpecialCourseTeacherRollMonthStatDetails({
        ...params,
        teacherMasterId: this.detailTeacherMasterId
      })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const cd = res.headers['content-disposition']
          let name = `特殊课程教师月到岗明细_${Date.now()}.xlsx`
          if (cd) {
            const m = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd)
            const raw = decodeURIComponent((m && (m[1] || m[2])) || '').trim()
            if (raw) name = raw
          }
          this.saveBlobFile(blob, name)
          this.$message.success('明细导出成功')
        })
        .catch(() => {
          this.$message.error('明细导出失败')
        })
        .finally(() => {
          this.detailExportLoading = false
        })
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    this.patchTimeOptions()
  }
}
</script>

<style scoped>
.sc-link-btn {
  font-weight: 500;
}

.detail-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px 16px;
  width: 100%;
}

.detail-dialog-footer /deep/ .detail-pager.el-pagination {
  padding: 0;
  margin: 0;
}

.roll-detail-table /deep/ td {
  vertical-align: middle;
  padding: 8px 6px;
}

.roll-detail-table /deep/ .cell {
  line-height: 1.35;
}

.roll-detail-2l__main {
  font-size: 13px;
  color: #303133;
  font-weight: 500;
  word-break: break-word;
}

.roll-detail-2l__sub {
  font-size: 12px;
  color: #909399;
  margin-top: 3px;
  word-break: break-word;
}

.roll-detail-2l--center .roll-detail-2l__main,
.roll-detail-2l--center .roll-detail-2l__sub {
  text-align: center;
}

.roll-detail-out--bad {
  color: #f56c6c !important;
  font-weight: 600;
}

.roll-detail-out--ok {
  color: #67c23a !important;
}

.roll-detail-out--sub {
  color: #e6a23c !important;
  font-weight: 500;
}

.roll-duty--ok {
  color: #67c23a;
  font-weight: 600;
}

.roll-duty--warn {
  color: #e6a23c;
  font-weight: 600;
}

.roll-duty--bad {
  color: #f56c6c;
  font-weight: 600;
}

.roll-duty--muted {
  color: #909399;
}

.sc-stat-table /deep/ .el-table__header-wrapper th {
  background: #f5f7fa !important;
  color: #606266;
  font-weight: 600;
  font-size: 13px;
}

.sc-stat-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  text-align: center;
  padding: 36px 16px;
  color: #909399;
}

.sc-stat-empty i {
  font-size: 40px;
  color: #dcdfe6;
  margin-bottom: 12px;
}

.sc-stat-empty p {
  margin: 0;
  font-size: 14px;
}

.sc-stat-empty__hint {
  margin-top: 8px !important;
  font-size: 12px;
  color: #c0c4cc;
}
</style>
